<router-outlet></router-outlet>
<app-event-details [conn]="false" [reOpen]="reOpen" ></app-event-details>

<app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
</app-notification-message>

<div class="d-flex gap-2 justify-content-flex-end align-items-top ms-4 me-4">
  <div id="clickableAwesomeFont" [hidden]="!fromDashboard">
   <button class="border-0 bg-dark black-button" *ngIf="isAccessible" style="cursor: pointer;">
    <fa-icon [icon]="faAddResolution" title="Add Resolution" class="addResolution" (click) =  "navAddResolutions()"></fa-icon>
   </button>
  </div>
  <div id="clickableAwesomeFont" [hidden]="!fromDashboard">
    <!-- <fa-icon [icon]="faEditresolution" title="Edit Resolution" class="editResolution" (click) =  "navEditResolutions($event)"></fa-icon> -->
  </div>
</div>

<div class="d-flex gap-5 justify-content-between align-items-top ms-4 me-4">
   <div class="grid">
      <label>Event Type </label>
      <span> {{ eventType }} </span>
   </div>
   <div class="grid">
      <label> Planned Unload </label>
      <span> {{ plannedUnload }} </span>
   </div>
   <div class="grid">
      <label> Region </label>
      <span> {{ eventRegion }} </span>
   </div>
   <div class="grid">
      <label> Route </label>
      <span> {{ eventRoute }}</span>
   </div>
   <div class="grid">
      <label> ETA </label>
      <span> {{ eventEta }}</span>
   </div>
</div>

<div *ngIf="check!=false" class="myDiv ms-4 me-4 mt-3">
   <div class="d-flex p-2 ps-3">
      <label><b> RESOLUTIONS </b> </label>
   </div>
</div>

<div *ngIf="check!=false" class="grid-agg ms-4 me-4 px-0 mt-2">
   <ag-grid-angular class="ag-theme-balham grid-items resolution_comp" (gridReady)="onGridReady($event);"
      (window:resize)="sizeToFit()" [rowHeight]="rowHeight" [rowData]="displayRowData" [animateRows]="true"
      [defaultColDef]="defaultColDef" [columnDefs]="columnDefs" [suppressPaginationPanel]="true" [headerHeight]="40"
      [floatingFiltersHeight]="40" [icons]="icons" [pagination]="true"
      [paginationPageSize]="paginationPageSize" [context]="context" (paginationChanged)="onPaginationChanged()" [rowClassRules]="rowClassRules"
      (filterChanged)="onFilterChanged($event)">

   </ag-grid-angular>
   <div class="d-flex pagination px-2 align-items-center justify-content-between">
      <div>
          <div>
              <label class="page-drpdwn-label me-2">Records/Page: </label>
              <select (change)="onPageSizeChanged($event)" class="paginate_drpdwn">
                  <option value="5">5</option>
                  <option value="10" selected>10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value={{rowCount}}>ALL</option>
              </select>
          </div>
      </div>
      <div class="d-flex align-items-center gap-3">
          <div>Viewing Records</div>


          <img src="assets/images/Icon awesome-fast-forward.svg" width="10" (click)="goToFirstPage()"
              class="text-primary reverse firstPage"
              [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">

          <img src="assets/images/Icon metro-next.svg" (click)="goToPreviousPage()" class="text-primary reverse previousPage"
              [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">

          <div>
              (
              <span class="value" id="lbCurrentPage"></span> -
              <span class="value" id="lbTotalPages"></span>)&nbsp; OF &nbsp;
              <span>{{rowCount}}</span>
          </div>


          <img src="assets/images/Icon metro-next.svg" (click)="goToNexpage()" class="text-primary nextPage"
              [ngClass]="{'disable_icon':(isLastPage()== true || rowCount==0),'enable_icon':(isLastPage()!= true || rowCount>0)}">
          <img src="assets/images/Icon awesome-fast-forward.svg" width="10" (click)="goToLastPage()"
              class="text-primary lastPage" [ngClass]="{'disable_icon':(isLastPage()== true || rowCount==0),'enable_icon':(isLastPage()!= true || rowCount>0)}">
      </div>
  </div>
</div>
